import { decryptId } from "../../../Components/CryptoComponent";
import AddLookup from "../../../Components/InputComponents/AddLookup";
import { useParams, useSearchParams } from "react-router-dom";

function EditCurrency() {
  const { id } = useParams();
  const decryptedId = decryptId(decodeURIComponent(id));

  const [searchParams] = useSearchParams();
  const redirectURL = `/CurrencyLookup?${searchParams.toString()}`;

  return (
    <AddLookup
      title="Edit Currency"
      alert="Currency Edited Successfully"
      editDataAPIEndPoint={`/Currency/${decryptedId}/edit`}
      viewDataDetailsAPIEndPoint={`/Currency/${decryptedId}/list_by_id`}
      redirectURL={redirectURL}
      submitMethod="put"
      sections={[
        {
          fields: [
            {
              type: "text",
              label: "Currency Code",
              name: "CL_Code",
              required: true, // Validation rule added here
              maxLength: 40,
            },
            {
              type: "text",
              label: "Currency",
              name: "CL_Name",
              required: true, // Validation rule added here
              maxLength: 40,
            },
            {
              type: "text",
              label: "Currency Symbol",
              name: "CL_Symbol",
              required: true, // Validation rule added here
              maxLength: 5,
            },
          ],
        },
      ]}
      validationRules={{
        CL_Code: {
          required: true,
        },
        CL_Name: {
          required: true,
        },
        CL_Symbol: {
          required: true,
        },
      }}
    />
  );
}

export default EditCurrency;
